import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "400",
  fill: "currentColor",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M921.6 309.248 737.28 415.744 564.224 209.92c15.36-13.824 24.576-33.792 24.576-56.32 0-42.496-34.304-76.8-76.8-76.8s-76.8 34.304-76.8 76.8c0 22.016 9.728 41.984 24.576 56.32L286.72 415.744 102.4 309.248l-25.6 44.544L236.032 947.2H788.48L947.2 353.792zM512 128c14.336 0 25.6 11.264 25.6 25.6s-11.264 25.6-25.6 25.6-25.6-11.264-25.6-25.6S497.664 128 512 128M247.808 793.6h528.896L749.056 896H274.944zm542.208-51.2H233.984l-94.72-352.256 159.232 91.648L509.44 230.4h5.12l210.944 251.392 159.232-91.648z" }, null, -1)
  ])))
}
export default { render: render }